import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { env } from '@amfam/environment';
import { profileQuery } from '@amfam/profile/data-access';
import { AnalyticsFacade, PageAnalyticParams } from '@amfam/shared/analytics';
import { fromRouterActions } from '@amfam/shared/utility/navigation';
import { CopyService, WindowRef } from '@amfam/shared/utility/shared-services';
import { LoadingSpinnerService, PageTitleService } from '@amfam/ui-kit';

import * as fromRoot from '../../../core/store';

@Component({
  selector: 'app-policy-landing',
  templateUrl: './policy-landing.component.html',
  styleUrls: ['./policy-landing.component.scss'],
  standalone: false
})
export class PolicyLandingComponent implements OnInit {
  hasSecurityQuestions: Observable<boolean>;
  private amfamDotCom: string = env.links.amfamDotComUrl;
  private componentName: any = {};
  private componentData: any;
  // **** Start of Analytics data for this component
  private pageAnalytic: PageAnalyticParams = {
    pageName: 'MyAccount:Business Policies',
    experience: '',
    primaryCategory: 'My Account',
    subCategory1: 'Business',
    subCategory2: 'Policies',
    subCategory3: ''
  };
  // **** End of Analytics data for this component

  constructor(
    private copyService: CopyService,
    private pageTitle: PageTitleService,
    public spinner: LoadingSpinnerService,
    private analyticsFacade: AnalyticsFacade,
    private win: WindowRef,
    private store: Store<fromRoot.RootState>
  ) {}

  ngOnInit() {
    this.componentName.policy = 'policy';
    this.componentData = this.copyService.getComponentData(this.componentName);
    this.hasSecurityQuestions = this.store.select(profileQuery.selectHasSecurityQuestions);
    this.pageTitle.set('Policies');
    this.spinner.stop();
    this.analyticsFacade.trackPage(this.pageAnalytic);
  }

  public addPersonalLine() {
    // TODO: this route is wrong and needs to be updated, not sure what the end point will be
    this.store.dispatch(
      fromRouterActions.Go({
        path: ['/enroll/conversion']
      })
    );
  }

  public requestQuote() {
    this.win.nativeWindow.open(this.amfamDotCom + 'insurance', '_blank');
  }
}
